// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3K8gU","colCheckbox":"styles_colCheckbox__2RPGX"};